import React from 'react';
import Hero from 'components/hero';
import { ReactComponent as Logo } from 'svg/min-logo.svg';
import './style.css';
import FancyButton from 'components/fancy-button';

const HomeIntro = () => {
  return (
    <Hero layout="vertical" className="h-full">
      <Logo className="intro-logo" />
      <h1 className="text-center">Welcome to MyShifts</h1>
      <div className="home-intro-buttons">
        <FancyButton className="home-intro-button" href="/workers">Health and Social Care Workers</FancyButton>
        <FancyButton className="home-intro-button" href="/employers">Health and Social Care Providers</FancyButton>
      </div>
    </Hero>
  );
};

export default HomeIntro;
